import React from 'react';
import { PageTitle } from '../../components';
import { TreeIntro, TreeBenefits, TreeTasks } from '../../sections';

const TreePage = () => {
    return (
        <>
            <PageTitle title={'Nasze korzenie'} page={'Drzewo Pokoleń'} />

            <div className='tree-page-wrapper'>
                <TreeIntro />
                <TreeBenefits />
                <TreeTasks />
            </div>
        </>
    );
};

export default TreePage;